import { Button } from "@ttc3k/trekker";
import { PageFlip } from "iconoir-react";
import { useState } from "react";
import { GlobalNotesModal } from "./components";
import { NotesContextProvider } from "shared/contextProviders";
import { useAppContext } from "useAppContext";
import { EnumOrganizationMetadataDisabledApps } from "gql/generated";
import { useLoggedInAs } from "shared/hooks";

export const GlobalNotes = () => {
  const [isFlyoutOpen, setIsFlyoutOpen] = useState(false);

  const { organizations } = useAppContext();
  const loggedInAs = useLoggedInAs();

  // If the organization has disabled the Notes app, do not show the Global Notes button
  const organization = organizations.find(
    organization => organization._id === loggedInAs?.entityId,
  );
  if (
    organization?.metadata?.disabledApps?.includes(
      EnumOrganizationMetadataDisabledApps.Notes,
    )
  )
    return null;

  return (
    <>
      <Button
        visual={"unstyled"}
        Icon={PageFlip}
        p={"0"}
        borderRadius={"full"}
        transitionProperty={"transform"}
        transitionDuration={"0.2s"}
        _hover={{
          transform: "scale(1.1)",
        }}
        _focusVisible={{
          transform: "scale(1.1)",
          outlineColor: "border.light",
          outlineOffset: "4px",
          outlineWidth: "1px",
          outlineStyle: "solid",
        }}
        onClick={() => setIsFlyoutOpen(true)}
      />
      <NotesContextProvider allowArchiving includeArchivedNotes hideDisplayDate>
        <GlobalNotesModal
          isOpen={isFlyoutOpen}
          onClose={() => setIsFlyoutOpen(false)}
        />
      </NotesContextProvider>
    </>
  );
};
